var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require('@/assets/img/404Logo.svg'),"alt":"404","draggable":"false"}}),_c('h1',[_vm._v("Страница не найдена")]),_c('router-link',{attrs:{"to":"/"}},[_c('button',{staticClass:"Btn404"},[_vm._v("Вернутся")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }